// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"996bc999","186":"9b20789c","225":"84e9a357","344":"ed713493","372":"95e7a8c5","377":"5609a057","443":"cc590cc2","738":"9788cbe0","841":"fdca125d","856":"a50d6760"}[chunkId] + ".chunk.js";
};